import type { NestedFilter } from '@@partner:types:graphql'
import type { FilterConfig } from '@components/common/filter/FilterConfig'

import React, { useCallback } from 'react'
import FilterPanel from '@components/common/filter/FilterPanel'
import { createFilter } from '@components/common/filter/FilterConfig'
import { prepareProductAttributesFilter } from '@@partner:helpers/productAttribute'

export interface ProductAttributesFiltersType {
  ids: string[]
  name: string
  label: string
  type: string
}

const defaultFilter: ProductAttributesFiltersType = {
  ids: [],
  name: '',
  label: '',
  type: ''
}

const filterConfig: FilterConfig[] = [
  createFilter.text('name', 'Название'),
  createFilter.text('label', 'Лейбл'),
  createFilter.text('type', 'Тип'),
  createFilter.multiline('ids', 'ID атрибутов (по строкам)', { expandable: true, rows: 3 })
]

export interface ProductAttributesFilterProps {
  onFilterChanged: (filters: NestedFilter) => void
}

export default function ProductAttributesFilter ({
  onFilterChanged
}: ProductAttributesFilterProps) {
  const handleSearch = useCallback((state: ProductAttributesFiltersType) => {
    onFilterChanged(prepareProductAttributesFilter(state))
  }, [ onFilterChanged ])

  return (
    <FilterPanel<ProductAttributesFiltersType>
      filters={filterConfig}
      defaultState={defaultFilter}
      onSearch={handleSearch}
    />
  )
}